// import { cloneDeep } from 'lodash';

export function setCookie(name: string, value: string, expiredays: number = 365) {
    const exDate = new Date();
    exDate.setDate(exDate.getDate() + expiredays);
    if (expiredays <= 0) {
        document.cookie = `${name}=${escape(value)};expires=${exDate.toUTCString()};path=/`;
    } else {
        document.cookie = `${name}=${escape(value)};path=/`;
    }
}

export function getCookie(name: string): string {
    if (document.cookie.length > 0) {
        let cStart = document.cookie.indexOf(name + '=');
        if (cStart !== -1) {
            cStart = cStart + name.length + 1;
            let cEnd = document.cookie.indexOf(';', cStart);
            if (cEnd === -1) {
                cEnd = document.cookie.length;
            }
            return unescape(document.cookie.substring(cStart, cEnd));
        }
    }
    return '';
}

export function clearCookie(name: string) {
    setCookie(name, '');
}

export function queryURL(name: string): string | null {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
    const result = window.location.search.substr(1).match(reg);
    if (result !== null) {
        return decodeURI(result[2]);
    }
    return null;
}
